import { createContext, useContext } from 'react';
import type { ResolvedBundleItem } from '../../shared/types';

export type BundleReviewReadyItem = Extract<ResolvedBundleItem, { kind: 'script' }>;

export interface BundleReviewContextValue {
  bundleSlug: string;
  bundleTitle: string;
  /** Ready scripts in bundle order, as of the switcher's last bundle fetch —
   *  used only to compute the "Next script" follow-on target, so a slightly
   *  stale snapshot is fine (the hub itself refetches independently). */
  items: BundleReviewReadyItem[];
}

/**
 * Optional context a bundle wrapper (BundleScriptView) provides so the
 * prop-less <ClientReview/> can add bundle-aware follow-on UI (Phase 3
 * "Next script" / "Back to all scripts") without taking any new props.
 * Absent for the standalone /s/:slug route — ClientReview must render
 * identically there.
 */
export const BundleReviewContext = createContext<BundleReviewContextValue | null>(null);

export function useBundleReview(): BundleReviewContextValue | null {
  return useContext(BundleReviewContext);
}
